import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const contents = [['📘', '6 Tomos de Primaria', 'Del tomo 1 al 6, año completo planificado.'], ['📐', '6 Tomos de Secundaria', 'De 1° a 6° año con progresión clara.'], ['🎨', 'Actividades paso a paso', 'Listas para imprimir y usar.'], ['📊', 'Evaluaciones y rúbricas', 'Instrumentos listos para cada nivel.'], ['🖌️', 'Técnicas artísticas', 'Materiales, procedimiento y ejemplos.'], ['🌍', 'Historia del Arte integrada', 'Movimientos y artistas por nivel.']];
export function KitContentsSection() {
  return <section id="contenido" className="scroll-mt-8 bg-brand-cream px-4 py-20 sm:py-24" data-id="element-102" data-mp="2o01lrb2chy3a">
      <Reveal className="mx-auto max-w-5xl" data-id="element-103" data-mp="2sxbmhmv6pw6f">
        <SectionHeading eyebrow="Qué incluye" title={<>
              <span aria-hidden="true" data-id="element-105" data-mp="32w0umnxa429h">📦</span> ¿Qué contiene el Pack Arte
              Lista?
            </>} data-id="element-104" data-mp="2xx6bfkvegbou" />
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-106" data-mp="10lvysq2ij0oo">
          {contents.map(([emoji, title, description]) => <article key={title} className="flex h-full flex-col rounded-2xl border border-brand-line bg-brand-alt p-7 shadow-[0_6px_20px_rgba(23,32,60,0.04)]" data-id="element-107" data-mp="vl7ytewb39ib">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-108" data-mp="mnnw01isp55l">
                {emoji}
              </span>
              <h3 className="mt-5 text-lg font-semibold leading-snug text-brand-navy" data-id="element-109" data-mp="1jdy8tiknfipy">
                {title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-110" data-mp="19lsgg7qhiza8">
                {description}
              </p>
            </article>)}
        </div>
      </Reveal>
    </section>;
}